import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, image, slug, keywords }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            keywords
            author
            icon
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const metaTitle = title || site.siteMetadata.title
  const metaSiteUrl = site.siteMetadata.siteUrl + slug || site.siteMetadata.siteUrl
  const metaKeywords = keywords || site.siteMetadata.keywords
  const metaImage = image
    ? site.siteMetadata.siteUrl + image.childImageSharp.resize.src
    : site.siteMetadata.icon

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link = {[
        { rel:"preconnect", href:"https://fonts.gstatic.com" },
      { rel:"preload", onload:"this.onload=null;this.rel='stylesheet'", as:"style", href:"https://fonts.googleapis.com/css2?family=Cookie&family=Nunito:wght@400;700&family=Roboto+Mono:ital,wght@0,400;0,700;1,400;1,700&family=Roboto:wght@400;700&display=swap"}
      ]} 
      title ={metaTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `keywords`,
          content: metaKeywords.join(", "),
        },
        {
          property: `og:title`,
          content: metaTitle,
        },

        {
          property: `og:url`,
          content: metaSiteUrl,
        },

        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `twitter:card`,
          content: `summary_large_image`,
        },

        {
          property: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          property: `twitter:title`,
          content: title,
        },
        {
          property: `twitter:description`,
          content: metaDescription,
        },
        {
          property: `twitter:url`,
          content: site.siteMetadata.siteUrl,
        },
      ]
        .concat(
          metaImage
            ? [
                {
                  property: `og:image`,
                  content: metaImage,
                },
                {
                  property: `twitter:image`,
                  content: metaImage,
                },
              ]
            : []
        )
        .concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
